// CB:BEGIN admin-reports-page
/**
 * Admin Reports Page
 * Displays financial reports dashboard with revenue, earnings, P&L, and transactions
 */
import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { FinancialReportsViewer } from '../../components/admin/FinancialReportsViewer';

export default function AdminReportsPage() {
  return (
    <AdminLayout title="Financial Reports">
      <FinancialReportsViewer />
    </AdminLayout>
  );
}
// CB:END admin-reports-page
